export class DataFlowNodeFactoryParams {
  public Type: string;

  public Data: any;

  public Callback: (data: object) => void;
}
